// biome-ignore lint/style/noRestrictedImports: encapsulation
import { entries, purry } from "remeda";

import { toArray } from "~/tools/to-array";

function _toEntries(data: Map<unknown, unknown> | object): Array<[unknown, unknown]> {
	if (data instanceof Map) {
		return toArray(data.entries());
	}
	return entries(data as { [key: string]: unknown }) as Array<[unknown, unknown]>;
}

type Entries = typeof entries;

interface ToEntries extends Entries {
	<K, V>(data: Map<K, V>): Array<[K, V]>;
}

export const toEntries = ((...args: ReadonlyArray<unknown>) => purry(_toEntries, args)) as ToEntries;
